import { FC } from "react";
import { withConditionalComponent } from "src/HOC";
import LocationComponentWeb from "./layouts/LocationComponent.web";
import LocationComponentMob from "./layouts/LocationComponent.mob";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { LocationIcon } from "src/assets/Icons";
import { useTranslation } from "react-i18next";
import i18n from "src/i18n";

const LocationSelectComponent = withConditionalComponent(LocationComponentWeb, LocationComponentMob);

const LocationComponent: FC<any> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const name = "location";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: LocationIcon,
    label: t("Hotels.search.hotelOrCity"),
    hasError,
    rules: [{ required: true, message: i18n.t("Hotels.search.locationRequired") }],
    className: "flex-5 h-15! border-none! focus:outline-none! focus-within:ring-0! text-font-default! w-full",
  };

  return <LocationSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default LocationComponent;
